var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckedThin = function SvgCheckedThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "21px",
    viewBox: "0 0 27 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path 4")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-338.000000, -353.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.049699,362.614038 C340.457922,362.034305 339.508224,362.044069 338.928491,362.635847 C338.348758,363.227625 338.358523,364.177323 338.950301,364.757056 L347.010847,372.65354 C347.614687,373.24509 348.587823,373.221096 349.161777,372.600507 L364.497714,356.018476 C365.060203,355.410283 365.023152,354.461259 364.41496,353.89877 C363.806767,353.336281 362.857743,353.373332 362.295254,353.981524 L348.007492,369.430213 L341.049699,362.614038 Z"
  })))));
};
export default SvgCheckedThin;